/* eslint-disable react/no-array-index-key, react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import { getImagem } from '../../utils/imagens';
import {
  itemPremiacaoPropType,
  regiaoPremiacaoPropType
} from '../../types/premiacoes';
import PremiacoesPorRegiao from './PremiacoesPorRegiao';
import '../../assets/scss/components/PremiacoesPage.scss';

const CardVencedor = ({ item, clear }) => {
  const iconeSrc = item.icone ? getImagem(item.icone) : null;
  const fotoSrc = item.foto ? getImagem(item.foto) : null;

  return (
    <div className={`premiacoes-card${clear ? ' premiacoes-card--clear' : ''}`}>
      <div className="premiacoes-card__header">
        {iconeSrc && (
          <img
            src={iconeSrc}
            alt={item.categoria?.replace(/<[^>]+>/g, '') || 'Categoria'}
          />
        )}
        <h3 dangerouslySetInnerHTML={{ __html: item.categoria }} />
      </div>
      {fotoSrc && (
        <img
          src={fotoSrc}
          className="premiacoes-card__image"
          alt={item.vencedor?.replace(/<[^>]+>/g, '') || 'Vencedor'}
        />
      )}
      <h4
        className="premiacoes-card__winner"
        dangerouslySetInnerHTML={{ __html: item.vencedor }}
      />
    </div>
  );
};

CardVencedor.propTypes = {
  item: itemPremiacaoPropType.isRequired,
  clear: PropTypes.bool
};

CardVencedor.defaultProps = {
  clear: false
};

const ResultadosFase3 = ({ dados, cidade }) => {
  const nomeCidade = cidade?.nome || 'nossa cidade';
  const horsConcours = dados?.horsConcours || [];
  const premiacao = dados?.premiacao || [];
  const regioes = dados?.regioes || [];

  const temVencedores =
    horsConcours.length > 0 || premiacao.length > 0 || regioes.length > 0;

  if (!temVencedores) {
    return (
      <div className="in-step-ctn-grid-ctt-result" id="vencedores">
        <div className="premiacoes-page__empty">
          <p>
            Os resultados da premiação de {nomeCidade} serão divulgados em
            breve.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="in-step-ctn-grid-ctt-result" id="vencedores">
      <div
        className="premiacoes-page"
        style={{ background: 'transparent', minHeight: 'auto' }}
      >
        <div
          className="premiacoes-page__container"
          style={{ padding: '20px 0', width: '100%' }}
        >
          {horsConcours.length > 0 && (
            <div
              className="premiacoes-page__section"
              style={{
                marginBottom:
                  premiacao.length > 0 || regioes.length > 0 ? 50 : 0
              }}
            >
              <h2>PREMIAÇÃO - HORS CONCOURS</h2>
              <div
                className="premiacoes-page__grid"
                style={{ justifyContent: 'center' }}
              >
                {horsConcours.map((item, idx) => (
                  <CardVencedor key={`hc-${idx}`} item={item} />
                ))}
              </div>
            </div>
          )}

          {regioes.length > 0 && <PremiacoesPorRegiao regioes={regioes} />}

          {premiacao.length > 0 && (
            <div className="premiacoes-page__section">
              <h2>PREMIAÇÃO</h2>
              <div
                className="premiacoes-page__grid"
                style={{ justifyContent: 'center' }}
              >
                {premiacao.map((item, idx) => (
                  <CardVencedor key={`prem-${idx}`} item={item} clear />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ResultadosFase3.propTypes = {
  dados: PropTypes.shape({
    regioes: PropTypes.arrayOf(regiaoPremiacaoPropType),
    horsConcours: PropTypes.arrayOf(itemPremiacaoPropType),
    premiacao: PropTypes.arrayOf(itemPremiacaoPropType)
  }),
  cidade: PropTypes.shape({
    nome: PropTypes.string
  })
};

ResultadosFase3.defaultProps = {
  dados: { horsConcours: [], premiacao: [] },
  cidade: null
};

export default ResultadosFase3;
